import { Toast } from '@capacitor/toast'
import { Capacitor } from '@capacitor/core'

const TOAST_DURATION_MS = { short: 2000, long: 3500 } as const

let activeToast: HTMLDivElement | undefined

function showWebToast(text: string, duration: 'short' | 'long') {
  if (activeToast) {
    activeToast.remove()
  }

  const el = document.createElement('div')
  el.textContent = text
  Object.assign(el.style, {
    position: 'fixed',
    bottom: '24px',
    left: '50%',
    transform: 'translateX(-50%)',
    background: 'rgba(0, 0, 0, 0.8)',
    color: '#fff',
    padding: '10px 20px',
    borderRadius: '8px',
    fontSize: '14px',
    zIndex: '99999',
    pointerEvents: 'none',
    transition: 'opacity 0.3s',
    opacity: '1',
  } satisfies Partial<Record<keyof CSSStyleDeclaration, string>>)

  document.body.appendChild(el)
  activeToast = el

  setTimeout(() => {
    el.style.opacity = '0'
    setTimeout(() => {
      el.remove()
      if (activeToast === el) activeToast = undefined
    }, 300)
  }, TOAST_DURATION_MS[duration])
}

export async function showToast(options: { text: string; duration?: 'short' | 'long' }) {
  const duration = options.duration ?? 'short'
  if (Capacitor.isNativePlatform()) {
    await Toast.show({ text: options.text, duration })
  } else {
    showWebToast(options.text, duration)
  }
}
